const Globals = {
  blogURI: 'blog'
}

module.exports = Globals
